<template>
    <div>
        <div slot="header" class="clearfix">
            <span class="icon iconfont icon-lingdang"></span><span>合同收款提醒</span>
            <el-switch @change="setRemindEnable(receipt.remindType,receipt.isEnable)"
                    v-model="receipt.isEnable"
                    active-color="#13ce66" inactive-text="不启用" active-text="启用">
            </el-switch>
        </div>
        <div :hidden="!receipt.isEnable">
            <el-form label-width="120px">
                <el-form-item label="首次提醒：">
                    <span>据收款到期</span>
                    <el-select v-model="receipt.firstRemind" size="mini"
                               @change="setFirstRemind(receipt.remindType,receipt.firstRemind)">
                        <el-option v-for="item in firstTimeRemindDays" :key="item" :label="item + '天'" :value="item" ></el-option>
                    </el-select><span>首次提醒</span>
                </el-form-item>

                <el-form-item label="首次提醒之后：">
                    <span @click="addRemindAfterFirstRemind('receipt')" v-if="receiptRemindList.length === 0" class="icon iconfont icon-plus"></span>
                    <div v-for="(detail,index) in receiptRemindList" :key="detail.uuid" class="remindDetail">
                        <span>距收款到期</span>
                        <el-select v-model="detail.distanceDays" size="mini"
                                   @change="setRemindDistanceDays(detail.uuid,detail.distanceDays)">
                            <template v-for="item in afterFirstTimeRemindDays">
                                <el-option v-if="item < (index === 0 ? receipt.firstRemind : receiptRemindList[index-1].distanceDays)" :key="item" :label="item + '天'" :value="item"></el-option>
                            </template>
                        </el-select>

                        <el-select v-model="detail.period" size="mini"
                                   @change="setRemindPeriod(detail.uuid,detail.period)">
                            <el-option v-for="item in dueTimeRemindDays" :key="item" :label="item + '天'" :value="item" ></el-option>
                        </el-select>
                        <span>提醒一次</span>
                        <span @click="addRemindAfterFirstRemind('receipt')" class="icon iconfont icon-plus"></span>
                        <span @click="delRemindAfterFirstRemind(detail.uuid,'receipt')" class="icon iconfont icon-subtract"></span>
                    </div>
                </el-form-item>

                <el-form-item label="收款到期：">
                    <el-select v-model="receipt.overdueRemind" size="mini"
                               @change="setOverdueRemind(receipt.remindType,receipt.overdueRemind)">
                        <el-option v-for="item in dueTimeRemindDays" :key="item" :label="item + '天'" :value="item" ></el-option>
                    </el-select><span>提醒一次</span>
                </el-form-item>
                <el-divider></el-divider>
                <el-form-item label="提醒人员：">
                    <el-select v-model="receipt.remindWay" size="mini"
                               @change="setRemindWay(receipt.remindType,receipt.remindWay)">
                        <el-option v-for="item in remindWayOptions" :key="item.value" :label="item.label" :value="item.value" ></el-option>
                    </el-select>
                    <el-select class="remindValues" v-model="receipt.remindValues" size="mini"
                               filterable multiple placeholder="请选择" @change="setRemindValues(receipt.remindType,receipt.remindValues)">
                        <el-option v-for="item in (receipt.remindWay === 'post' ? postOptions : staffOptions)" :key="item.uuid" :label="item.name" :value="item.uuid" ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>

        <div slot="header" class="clearfix">
            <span class="icon iconfont icon-lingdang"></span><span>续费提醒</span>
            <el-switch @change="setRemindEnable(renewal.remindType,renewal.isEnable)"
                       v-model="renewal.isEnable"
                       active-color="#13ce66" inactive-text="不启用" active-text="启用">
            </el-switch>
        </div>
        <div :hidden="!renewal.isEnable">
            <el-form label-width="120px">
                <el-form-item label="首次提醒：">
                    <span>据收款到期</span>
                    <el-select v-model="renewal.firstRemind" size="mini"
                               @change="setFirstRemind(renewal.remindType,renewal.firstRemind)">
                        <el-option v-for="item in firstTimeRemindDays" :key="item" :label="item + '天'" :value="item" ></el-option>
                    </el-select><span>首次提醒</span>
                </el-form-item>

                <el-form-item label="首次提醒之后：">
                    <span @click="addRemindAfterFirstRemind('renewal')" v-if="renewalRemindList.length === 0" class="icon iconfont icon-plus"></span>
                    <div v-for="(detail,index) in renewalRemindList" :key="detail.uuid" class="remindDetail">
                        <span>距收款到期</span>
                        <el-select v-model="detail.distanceDays" size="mini"
                                   @change="setRemindDistanceDays(detail.uuid,detail.distanceDays)">
                            <template v-for="item in afterFirstTimeRemindDays">
                                <el-option v-if="item < (index === 0 ? renewal.firstRemind : renewalRemindList[index-1].distanceDays)" :key="item" :label="item + '天'" :value="item"></el-option>
                            </template>
                        </el-select>

                        <el-select v-model="detail.period"  size="mini"
                                   @change="setRemindPeriod(detail.uuid,detail.period)">
                            <template v-for="item in dueTimeRemindDays">
                                <el-option v-if="item < (index === 0 ? renewal.firstRemind : renewalRemindList[index-1].period)" :key="item" :label="item + '天'" :value="item"></el-option>
                            </template>
                        </el-select>
                        <span>提醒一次</span>
                        <span @click="addRemindAfterFirstRemind('renewal')" class="icon iconfont icon-plus"></span>
                        <span @click="delRemindAfterFirstRemind(detail.uuid,'renewal')" class="icon iconfont icon-subtract"></span>
                    </div>
                </el-form-item>

                <el-form-item label="收款到期：">
                    <el-select v-model="renewal.overdueRemind" size="mini"
                               @change="setOverdueRemind(renewal.remindType,renewal.overdueRemind)">
                        <el-option v-for="item in dueTimeRemindDays" :key="item" :label="item + '天'" :value="item" ></el-option>
                    </el-select><span>提醒一次</span>
                </el-form-item>
                <el-divider></el-divider>
                <el-form-item label="提醒人员：">
                    <el-select v-model="renewal.remindWay" size="mini"
                               @change="setRemindWay(renewal.remindType,renewal.remindWay)">
                        <el-option v-for="item in remindWayOptions" :key="item.value" :label="item.label" :value="item.value" ></el-option>
                    </el-select>
                    <el-select class="remindValues" v-model="renewal.remindValues" size="mini"
                               filterable multiple placeholder="请选择" @change="setRemindValues(renewal.remindType,renewal.remindValues)">
                        <el-option v-for="item in (renewal.remindWay === 'post' ? postOptions : staffOptions)" :key="item.uuid" :label="item.name" :value="item.uuid" ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import remindConfigService from "../../service/remindConfigService";
    import dictionaryService from "../../service/dictionaryService";
    import {Message} from "element-ui";

    export default {
        data: function () {
            return {
                firstTimeRemindDays: [1,2,3,4,5,7,10,15,20,30],
                afterFirstTimeRemindDays: [1,2,3,4,5,7,10,15,20],
                dueTimeRemindDays: [1,2,3,4,5,7,10],
                remindWayOptions: [
                    {
                        value:'post',
                        label:'按岗位'
                    },
                    {
                        value:'staff',
                        label:'按员工'
                    }
                ],
                postOptions: [],
                staffOptions: [],
                receipt: {},
                receiptRemindList: [],
                renewalRemindList: [],
                renewal: {},
            }
        },
        mounted: async function () {
            let resp = await remindConfigService.getRemindList();
            if (resp.data.Status === '1'){
                _.each(resp.data.Data,item => {
                    if (item.remindType === 'receipt') {
                        item.remindValues = item.remindValues ? item.remindValues.split(','):[];
                        this.receipt = item;
                        this.receiptRemindList = item.detail;
                    } else {
                        item.remindValues = item.remindValues ? item.remindValues.split(','):[];
                        this.renewal = item;
                        this.renewalRemindList = item.detail;
                    }
                })
            }else {
                Message.error("获取数据失败")
            }
            let staffResp = await dictionaryService.getItems('base_staff');
            if (staffResp.data.Status === '1'){
                this.staffOptions = staffResp.data.Data;
            }
            let postResp = await dictionaryService.getItems('base_position');
            if (postResp.data.Status === '1'){
                this.postOptions = postResp.data.Data;
            }

        },
        methods:{
            /**
             * 删除首次提醒后的提醒设置
             */
            async delRemindAfterFirstRemind(uuid,type){
               let resp = await remindConfigService.delRemindAfterFirstRemind(uuid);
               if (resp.data.Status === '1'){
                   Message.success("删除成功");
                   type === 'receipt' ?
                       this.receiptRemindList = this.receiptRemindList.filter(item => item.uuid != uuid) :
                       this.renewalRemindList = this.renewalRemindList.filter(item => item.uuid != uuid);

               } else {
                   Message.error(resp.data.Message)
               }
            },
            /**
             * 添加首次提醒后的提醒设置
             */
            async addRemindAfterFirstRemind(type){
               let resp = await remindConfigService.addRemindAfterFirstRemind(type);
               if (resp.data.Status === '1'){
                   Message.success("添加成功");
                   type === 'receipt' ?
                       this.receiptRemindList = [...this.receiptRemindList, ...[{uuid:resp.data.Data}]] :
                       this.renewalRemindList = [...this.renewalRemindList, ...[{uuid:resp.data.Data}]]  ;
               } else {
                   Message.error(resp.data.Message)
               }
            },
            /**
             * 是否启用提醒
             */
            async setRemindEnable(type,isEnable){
               let resp = await remindConfigService.setRemindEnable(type,isEnable);
               if (resp.data.Status === '1'){
                   Message.success("设置成功");
               } else {
                   Message.error(resp.data.Message)
               }
            },
            /**
             * 修改首次提醒时间
             */
            async setFirstRemind(type,firstRemind){
               let resp = await remindConfigService.setFirstRemind(type,firstRemind);
               if (resp.data.Status === '1'){
                   Message.success("设置成功");
               } else {
                   Message.error(resp.data.Message)
               }
            },

            /**
             * 修改提醒方式
             */
            async setRemindWay(type,remindWay){
               let resp = await remindConfigService.setRemindWay(type,remindWay);
               if (resp.data.Status === '1'){
                   Message.success("设置成功");
                   type === 'receipt' ? this.receipt.remindValues = [] : this.renewal.remindValues = [];
               } else {
                   Message.error(resp.data.Message)
               }
            },

            /**
             * 修改逾期提醒天数
             */
            async setOverdueRemind(type,overdueRemind){
               let resp = await remindConfigService.setOverdueRemind(type,overdueRemind);
               if (resp.data.Status === '1'){
                   Message.success("设置成功");
               } else {
                   Message.error(resp.data.Message)
               }
            },
            /**
             * 修改首次提醒后距收款N天时间
             */
            async setRemindDistanceDays(uuid,distanceDays){
               let resp = await remindConfigService.setRemindDistanceDays(uuid,distanceDays);
               if (resp.data.Status === '1'){
                   Message.success("设置成功");
               } else {
                   Message.error(resp.data.Message)
               }
            },
            /**
             * 修改首次提醒后距收款N天时间没N天提醒周期
             */
            async setRemindPeriod(uuid,period){
               let resp = await remindConfigService.setRemindPeriod(uuid,period);
               if (resp.data.Status === '1'){
                   Message.success("设置成功");
               } else {
                   Message.error(resp.data.Message);
                   let remind = this.receiptRemindList.filter(item=>item.uuid= uuid);
                   remind[0].period = 0;
               }
            },
            /**
             * 修改提醒人员/提醒岗位
             */
            async setRemindValues(type,remindValues){
               let resp = await remindConfigService.setRemindValues(type,remindValues.join(','));
               if (resp.data.Status === '1'){
                   Message.success("设置成功");
               } else {
                   Message.error(resp.data.Message);
               }
            }
        },
        watch: {

        }
    }
</script>

<style scoped>
    .el-switch{
        float: right;
    }
    .clearfix{
        padding: 14px;
        background: #f5f5f5;
    }
    .remindDetail{
        margin-bottom: 8px;
    }
    .el-select {
        margin: 0 4px;
        width: 84px;
    }
    .el-form{
        margin-top: 16px;
    }
    .icon{
        margin-left: 0.5rem;
    }
    .el-form-item {
        margin-bottom: 16px;
    }
    .remindValues{
        width: 280px;
    }
</style>